<div mat-dialog-title>
  <span>{{ title | translate: {name: view?.name} }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<div mat-dialog-content>
  <q9-text-field
    [formControl]="nameControl"
    label="GRID_VIEWS.EDIT_VIEW_NAME_LABEL"></q9-text-field>

  <div class="columns" cdkDropListGroup>
    <div>
      <div>{{ 'GRID_VIEWS.COLUMNS_AVAILABLE_LABEL' | translate }}</div>

      <div
        cdkDropList
        id="available"
        cdkDropListLockAxis="x"
        cdkDropListSortingDisabled
        [cdkDropListData]="available"
        (cdkDropListDropped)="drop($event)">
        <ng-container *ngFor="let column of available">
          <div cdkDrag class="column" cdkDragBoundary=".columns">
            {{ column.title | translate }}
          </div>
        </ng-container>
      </div>
    </div>

    <div>
      <div>{{ 'GRID_VIEWS.COLUMNS_INCLUDED_LABEL' | translate }}</div>

      <div
        cdkDropList
        id="included"
        cdkDropListLockAxis="x"
        cdkDropListSortingDisabled
        [cdkDropListData]="included"
        (cdkDropListDropped)="drop($event)"
        [ngClass]="{invalid: included.length < 2 && columnWasDropped}">
        <ng-container *ngFor="let column of included">
          <div cdkDrag class="column" cdkDragBoundary=".columns" [cdkDragDisabled]="column.locked">
            {{ column.title | translate }}
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <q9-secondary-button mat-dialog-close>
    {{ 'GENERAL.CANCEL' | translate }}
  </q9-secondary-button>

  <q9-primary-button (click)="onSubmit()" [isLoading]="isSubmitted">
    {{ 'GENERAL.CONFIRM' | translate }}
  </q9-primary-button>
</div>
